import type { MetricFilters } from './metric-widget'

const FILTER_FIELDS: Record<keyof MetricFilters, string> = {
  workspaceIds: 'workspaceId',
  groupIds: 'groupIds',
  channelIds: 'channelId',
  reportToIds: 'assignedSupervisorId',
  handledBy: 'handledByIds',
  assignedTo: 'assignedTo',
  scorecardIds: 'scorecardId',
  reviewed: 'reviewedAt',
}

export function hasEditableMetricFilters(
  filters: MetricFilters,
  isFilterAllowed: (field: string) => boolean,
) {
  return Object.entries(filters).some(([key, filter]) => {
    if (!filter || !isFilterAllowed(FILTER_FIELDS[key as keyof MetricFilters]))
      return false
    return 'values' in filter ? filter.values.length > 0 : true
  })
}

export function preserveReadOnlyMetricFilters(
  filters: MetricFilters,
  isFilterAllowed: (field: string) => boolean,
): MetricFilters {
  return Object.fromEntries(
    Object.entries(filters).filter(([key]) => {
      return !isFilterAllowed(FILTER_FIELDS[key as keyof MetricFilters])
    }),
  ) as MetricFilters
}
